module.exports = __webpack_public_path__ + "img/corridor_btn_library.cd4f8336.png";